module.exports = __webpack_public_path__ + "static/media/firstFloorSide.cc721641.png";